<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="f.valid && resetPassword(f)">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_RESET_PASSWORD'"></h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <xrx-input
      type="password"
      id="newPassword"
      name="newPassword"
      [(ngModel)]="resetObj.newPassword"
      [minlength]="8"
      [maxlength]="30"
      autocomplete="off"
      placeholder="SDE_NEW_PASSWORD"
      [required]="true"
      [ishalf]="true"
      label="SDE_NEW_PASSWORD"
      patternerror="SDE_PASSWORD_FORMAT_INVALID"></xrx-input>

    <xrx-input
      type="password"
      id="confirmPassword"
      name="confirmPassword"
      [(ngModel)]="confirmPassword"
      [minlength]="8"
      [maxlength]="30"
      autocomplete="off"
      placeholder="SDE_CONFIRM_PASSWORD"
      [required]="true"
      [ishalf]="true"
      compareto="newPassword"
      matcherror="SDE_PASSWORDS_DO_NOT2"
      label="SDE_CONFIRM_PASSWORD"
      helpBlock="SDE_PASSWORDS_MUST_BE2"></xrx-input>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button type="submit" class="xrx-btn btn-primary">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
</form>
